<template>
  <div id="app">
    <div id="nav"></div>
    <router-view />
  </div>
</template>

<style>
body {
  text-align: center;
  font-family: "Raleway", sans-serif;
  margin: 0;
  padding: 0;
  min-width: 280px;
  min-height: 100vh;
}
</style>
